<template>
  <div>
    <v-dialog v-model="model" max-width="1200" persistent scrollable>
      <material-card
        v-if="model"
        :title="$t('components.memberview.archived_notes_{0}', [name])"
        :color="$vuetify.theme.themes.light.primary"
        icon="find_in_page"
      >
        <v-card-text>
          <employer-notes-table :employerIdentityId="id" :showActive="false" />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
// import { mapActions, mapGetters } from "vuex";
// import EmployerNotesForm from "@/components/Employers/EmployerNotesForm.vue";
import EmployerNotesTable from "@/components/Employers/EmployerNotesTable.vue";

export default {
  components: {
    // EmployerNotesForm
    EmployerNotesTable
  },
  props: ["model", "id", "name"],
  data() {
    return {
    };
  },
  computed: {
    // ...mapGetters("common", { selectedPlan: "plan" }),
    // ...mapGetters("plansMembers", ["options", "planOptions", "planIdentity"]),
    // ...mapGetters("common", ["language"]),
  },
  watch: {
    // model: {
    //   handler(v) {
    //     if (v) {
    //       this.loadItem();
    //     }
    //   },
    // },
  },
  methods: {
    // ...mapActions("plansMembers", ["getEmployerForLogo", "updateEmployerLogo"]),    
  },
};
</script>
